import { render, staticRenderFns } from "./AnswerType.vue?vue&type=template&id=ee82c4e6"
import script from "./AnswerType.vue?vue&type=script&lang=js"
export * from "./AnswerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports